import { a as h } from "./variables-37cba309-153935bd.js";
var M = {
    /**
     * SVG path of the left handle at non-small breakpoints
     */
    leftHandlePath: function leftHandlePath(l, a, t, e) {
      return ["M", 0, 0, "H", l - t / 2 + 1, "V", 24, "H", 0, "V", a, "Z", "M", -6, 16, "l", -4, -4, 4, -4, "v", 8, "Z"];
    },
    /**
     * SVG path of the left handle at small breakpoint
     */
    leftHandleMiniPath: function leftHandleMiniPath(l, a, t, e) {
      return ["M", 0, 0, "H", l - t / 2 + 1, "V", 24, "H", 0, "V", a, "Z", "M", -3, 16, "l", -3, -4, 3, -4, "v", 8, "Z"];
    },
    /**
     * SVG path of the right handle at non-small breakpoints
     */
    rightHandlePath: function rightHandlePath(l, a, t, e) {
      return ["M", 0, 0, "H", t, "V", e, "H", l + t / 2 + 1, "V", a, "Z", "M", 6, 16, "l", 4, -4, -4, -4, "v", 8, "Z"];
    },
    /**
     * SVG path of the right handle at small breakpoint
     */
    rightHandleMiniPath: function rightHandleMiniPath(l, a, t, e) {
      return ["M", 0, 0, "H", t, "V", e, "H", l + t / 2 + 1, "V", a, "Z", "M", 3, 16, "l", 3, -4, -3, -4, "v", 8, "Z"];
    }
  },
  n = "lefthandle",
  i = "righthandle",
  H = 24;
function d() {
  return {
    height: H,
    lineWidth: 0,
    symbols: [n, i],
    width: parseInt(h, 10)
  };
}
export { d, M as o };